(function($) {
    /**
     * Show or hide the shipping address fields based on the selected shipping method.
     * Specifically, hides them if "local_pickup_plus" is selected, and unchecks the
     * "Ship to a different address?" checkbox to keep the UI consistent.
     */
    function toggleShippingAddressFields() {
        // console.log('toggle fields in checkout');
        // Find the main container for shipping address fields
        var shippingFields = $('.checkout-details__shipping');
        var addNewShipping = $('#shipping_tiles');

        // console.log(shippingFields);

        // If it doesn't exist, exit early (after some quick changes)
        if (!shippingFields.length) {
            var collectButtonChecked = document.querySelector(
                '.delivery-buttons__button--collect.delivery-buttons__button--checked'
            );

            var deliveryButtonChecked = document.querySelector(
                '.delivery-buttons__button--delivery.delivery-buttons__button--checked'
            );

            var continueButton = document.querySelector('.cart-totals__continue-button');

            if (!collectButtonChecked && !deliveryButtonChecked && continueButton) {
                continueButton.classList.add('disabled');
            }

            return;
        }

        // Get the currently selected shipping method radio input
        var selectedMethodInput = $('input[name^="shipping_method"]:checked');

        // Get the value of the selected shipping method
        var selectedMethod = selectedMethodInput.length ? selectedMethodInput.val() : '';

        // console.log(selectedMethod);

        // Get the "Ship to a different address?" checkbox
        var shipCheckbox = $('#ship-to-different-address-checkbox');

        // If "local_pickup_plus" is selected...
        if (selectedMethod.includes('local_pickup_plus')) {
            // Hide the shipping address section
            shippingFields.hide();
            if(addNewShipping) {
                addNewShipping.hide();
            }

            // If the "Ship to a different address?" checkbox is checked, uncheck it
            // (without triggering a change event to avoid loops)
            if (shipCheckbox.length && shipCheckbox.prop('checked')) {
                shipCheckbox.prop('checked', false);
            }
        // if the collect method is checked but its not actually selected as the method (happens when there is a bug)
        } else if((document.querySelector('.delivery-buttons__button--collect.delivery-buttons__button--checked'))) {
            
            // Hide the shipping address section
            shippingFields.hide();
            // Also hide fields with these IDs (this is the slector in the checkout sidebar)
            $('#pickup-location-field-for-0').hide();
            $('#pickup-items-field-for-0').hide();

            // Hide the "Enter your address..." message
            $('.checkout-review__total-cell--shipping p').filter(function () {
                return $(this).text().trim() === 'Enter your address to see all available shipping options.';
            }).hide();

            // If the "Ship to a different address?" checkbox is checked, uncheck it
            // (without triggering a change event to avoid loops)
            if (shipCheckbox.length && shipCheckbox.prop('checked')) {
                shipCheckbox.prop('checked', false);
            }
        } else {
            // Show the shipping address section for other methods
            shippingFields.show();
            if(addNewShipping) {
                addNewShipping.show();
            }
        }
    }

    // Run on initial page load
    $(document).ready(function() {
        toggleShippingAddressFields();
    });

    // Re-run the logic whenever WooCommerce updates the checkout (e.g. AJAX refresh)
    $('body').on('updated_checkout', toggleShippingAddressFields);

    // Also run when a user manually changes the shipping method radio button
    $('body').on('change', 'input[name^="shipping_method"]', toggleShippingAddressFields);

})(jQuery);
